export class ForTheRecord {
    constructor(socket, log) {
        this.socket = socket;
        this.asyncHandlers = [
            {
                name: 'startRecord',
                regExp: /#\d+StartRec/i,
                callback: (match) => {
                    this.socket.send('#14RecStarted');
                },
            },
            {
                name: 'stopRecording',
                regExp: /#\d+StopRec/i,
                callback: (match) => {
                    this.socket.send('#14RecStopped');
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => { },
            },
        ];
    }
}
ForTheRecord.emulatorType = 'socketEmulator';
ForTheRecord.key = '-N84JcLcVUAlnT3u9UZB';
